import { regex } from '../common'

export default regex(/^\d*(\.\d+)?$/)
